import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import UserPersonasSection from '../components/UserPersonasSection';
import ContactSection from '../components/ContactSection';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Handle scroll to section from other pages
    const scrollToSection = sessionStorage.getItem('scrollToSection');
    const hashFragment = window.location.hash.replace('#', '');
    
    // Priority order: sessionStorage > hash fragment > top of page
    if (scrollToSection) {
      sessionStorage.removeItem('scrollToSection');
      
      const targetElement = document.getElementById(scrollToSection);
      if (targetElement) {
        const headerOffset = 120;
        const elementPosition = targetElement.offsetTop;
        const offsetPosition = elementPosition - headerOffset;
        
        // Use setTimeout to ensure the DOM has rendered
        setTimeout(() => {
          try {
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          } catch (e) {
            // Fallback for browsers that don't support scroll behavior
            window.scrollTo(0, offsetPosition);
          }
        }, 200);
      }
    } else if (hashFragment) {
      // Handle hash fragments in URL (like /#contact)
      const targetElement = document.getElementById(hashFragment);
      if (targetElement) {
        const headerOffset = 120;
        const elementPosition = targetElement.offsetTop;
        const offsetPosition = elementPosition - headerOffset;
        
        setTimeout(() => {
          try {
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          } catch (e) {
            window.scrollTo(0, offsetPosition);
          }
        }, 200);
      }
    } else if (window.location.pathname === '/' && !window.location.hash) {
      // Only scroll to top if we're on the root path with no hash
      // This prevents interfering with React Router navigation
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition > 100) {
        window.scrollTo(0, 0);
      }
    }

    // Set up intersection observer for fade-in animations
    const sections = document.querySelectorAll('section');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sections.forEach(section => {
      section.classList.add('fade-in-section');
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header isMainPage={true} />
      <main className="flex-grow-1">
        <HeroSection />
        <AboutSection />
        <UserPersonasSection />
        <ServicesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;